import Alpine from "alpinejs";

export function getStore(name, { create = false, seed = {} } = {}) {
    try {
        const s = Alpine.store(name);
        if (s) return s;
    } catch (_) { /* ignore */ }

    if (create) {
        const init = (typeof seed === 'function') ? seed() : seed;
        Alpine.store(name, init);
        return Alpine.store(name);
    }

    return null;
}
